import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateLabourForecastInput,
  UpdateLabourForecastMutation,
} from '@/gql/graphql';

const UPDATE_LABOUR_FORECAST_MUTATION = graphql(`
  mutation UpdateLabourForecast($input: UpdateLabourForecastInput!) {
    updateLabourForecast(input: $input) {
      id
    }
  }
`);

const useUpdateLabourForecast = (
  projectId: string,
  options?: UseMutationOptions<
    UpdateLabourForecastMutation,
    unknown,
    UpdateLabourForecastInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_LABOUR_FORECAST_MUTATION, { input });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.labourForecasts(projectId),
      });
      void queryClient.invalidateQueries({
        queryKey: projectKeys.profitBreakdown(projectId),
      });
    },
    ...options,
  });
};

export default useUpdateLabourForecast;
